export default __webpack_public_path__ + "static/media/Gilroy-Light.1822a291.ttf";